var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeckoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 260,
    height: 60.702,
    viewBox: "0 0 260 60.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_262",
    "data-name": "Groupe 262",
    transform: "translate(-778 -11640.298)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_260",
    "data-name": "Groupe 260",
    transform: "translate(-150 8021.956)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_230",
    "data-name": "Rectangle 230",
    width: 184,
    height: 33,
    transform: "translate(928 3626.963)",
    fill: "#a3a8b1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_55",
    "data-name": "Groupe 55",
    transform: "translate(928 3603.044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_3",
    "data-name": "Trac\\xE9 3",
    d: "M337.447,56.056V94.01h-50.02v3.544h102.38v-41.5Z",
    transform: "translate(-129.807 -37.211)",
    fill: "#fcbc1e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_6",
    "data-name": "Groupe 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2",
    "data-name": "Groupe 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_10",
    "data-name": "Trac\\xE9 10",
    d: "M65.547,92.565h52.361V54.61h50.036V51.064H65.547Z",
    transform: "translate(-65.547 -35.765)",
    fill: "#a3a8b1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11",
    "data-name": "Trac\\xE9 11",
    d: "M213.329,51.064V54.61h50.044V92.565h2.594V54.61h50.02V51.064Z",
    transform: "translate(-108.347 -35.765)",
    fill: "#a3a8b1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3",
    "data-name": "Groupe 3",
    transform: "translate(52.361 18.845)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_12",
    "data-name": "Trac\\xE9 12",
    d: "M191.875,56.056h-2.584V94.01H139.254v3.544H241.92V94.01H191.875Z",
    transform: "translate(-139.254 -56.056)",
    fill: "#fcbc1e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_4",
    "data-name": "Groupe 4",
    transform: "translate(52.361 18.845)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 50.037,
    height: 37.955,
    fill: "#de9300"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 50.045,
    height: 37.955,
    transform: "translate(52.621)",
    fill: "#de9300"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 50.02,
    height: 37.955,
    transform: "translate(105.259)",
    fill: "#de9300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_13",
    "data-name": "Trac\\xE9 13",
    d: "M313.706,77.6l11.836-9.358h5.319L318.7,77.892l13.538,11.194H326.77L313.706,78.4Z",
    transform: "translate(-137.418 -40.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_5",
    "data-name": "Groupe 5",
    transform: "translate(16.697 26.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_14",
    "data-name": "Trac\\xE9 14",
    d: "M99.082,68.255H89.051V89.091h10.2c6.878,0,11.694-3.439,11.694-10.546C110.948,71.036,105.675,68.255,99.082,68.255Zm-1.834,17.34H93.121V71.753h4.127c6.821,0,9.629,1.747,9.629,6.849C106.877,83.474,104.184,85.595,97.248,85.595Z",
    transform: "translate(-89.051 -67.739)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_15",
    "data-name": "Trac\\xE9 15",
    d: "M165.98,80.093h12.582V76.6H165.98V71.752H180.6v-3.5H161.91V89.092h19.03V85.6H165.98Z",
    transform: "translate(-110.152 -67.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_16",
    "data-name": "Trac\\xE9 16",
    d: "M387.743,67.529c-9.17,0-12.41,5.388-12.41,11.093,0,4.327,2.55,10.776,12.41,10.776s12.41-6.449,12.41-10.776C400.152,72.917,396.914,67.529,387.743,67.529Zm0,18.371c-3.9,0-8.338-1.6-8.338-7.509,0-5.015,3.58-7.365,8.338-7.365s8.341,2.35,8.341,7.365C396.083,84.3,391.64,85.9,387.743,85.9Z",
    transform: "translate(-171.963 -67.529)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_17",
    "data-name": "Trac\\xE9 17",
    d: "M309.063,89.086h4.058V68.236h-4.058Z",
    transform: "translate(-152.77 -67.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_18",
    "data-name": "Trac\\xE9 18",
    d: "M244.171,85.9c-4.472,0-7.939-2.521-7.939-7.308,0-4.328,2.407-7.568,8.167-7.568,4.873,0,6.48,2.953,6.708,3.669h4.069c-.315-1.118-1.689-7.164-11-7.164-8.284,0-12.094,4.527-12.094,10.6,0,7.595,5.186,11.262,11.777,11.262,9.575,0,11.236-5.616,11.638-7.939h-4.069C251.021,83.066,248.927,85.9,244.171,85.9Z",
    transform: "translate(-130.474 -67.53)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_379",
    "data-name": "Trac\\xE9 379",
    d: "M286.156,102.7h3.98c2.616,0,4.708,1.105,4.708,4.088,0,2.823-1.91,4.189-4.64,4.189h-4.047Zm3.251,6.889c2.752,0,3.821-.843,3.821-2.778,0-2.027-1.114-2.721-3.821-2.721h-1.636v5.5Z",
    transform: "translate(649.389 11589.817)",
    fill: "#9c9d9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_380",
    "data-name": "Trac\\xE9 380",
    d: "M323.094,102.413c3.638,0,4.924,2.14,4.924,4.406,0,1.718-1.013,4.281-4.924,4.281s-4.924-2.562-4.924-4.281c0-2.265,1.286-4.406,4.924-4.406m3.308,4.315c0-1.992-1.421-2.927-3.308-2.927s-3.309.935-3.309,2.927c0,2.345,1.762,2.982,3.309,2.982s3.308-.637,3.308-2.982",
    transform: "translate(640.117 11589.9)",
    fill: "#9c9d9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_381",
    "data-name": "Trac\\xE9 381",
    d: "M356.741,102.413c3.639,0,4.924,2.14,4.924,4.406,0,1.718-1.012,4.281-4.924,4.281s-4.923-2.562-4.923-4.281c0-2.265,1.285-4.406,4.923-4.406m3.308,4.315c0-1.992-1.421-2.927-3.308-2.927s-3.308.935-3.308,2.927c0,2.345,1.762,2.982,3.308,2.982s3.308-.637,3.308-2.982",
    transform: "translate(630.372 11589.9)",
    fill: "#9c9d9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_382",
    "data-name": "Trac\\xE9 382",
    d: "M386.217,102.7h4.968c1.956,0,3.367.444,3.367,2.471a2.341,2.341,0,0,1-2.309,2.436l2.535,3.37h-1.989l-2.4-3.256h-2.56v3.256h-1.613Zm4.73,3.678c1.318,0,1.99-.193,1.99-1.173s-.671-1.161-1.99-1.161H387.83v2.334Z",
    transform: "translate(620.409 11589.817)",
    fill: "#9c9d9f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_383",
    "data-name": "Trac\\xE9 383",
    d: "M425.183,105.134c-.26-.74-.931-1.377-2.9-1.377-1.092,0-2.194.273-2.194,1.036,0,.353.2.729,1.853.934l1.955.3c1.855.285,2.946,1,2.946,2.39,0,1.959-1.865,2.687-4.07,2.687-3.548,0-4.412-1.753-4.606-2.379l1.558-.49c.3.6.911,1.48,3.094,1.48,1.318,0,2.41-.432,2.41-1.15,0-.534-.613-.887-1.8-1.036l-1.978-.273c-1.911-.261-2.979-1.093-2.979-2.356,0-2.482,3.217-2.482,3.852-2.482,3.56,0,4.174,1.651,4.38,2.221Z",
    transform: "translate(611.156 11589.9)",
    fill: "#9c9d9f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeckoLogo);
export default __webpack_public_path__ + "static/media/decko-logo.95b0e0dc4523af5d6cc46695d1ae5a28.svg";
export { ForwardRef as ReactComponent };